
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class RenderTable extends Vue {
  @Prop({ required: true }) headers!: any[]
  @Prop({ required: true }) items!: any[]
  @Prop({ default: 10 }) itemsPerPage!: number
  @Prop({ default: false }) loading!: boolean;

  get footerProps() {
    return {
      'items-per-page-options': [
        5,
        10,
        25,
        50,
        { text: 'Todas', value: -1 }
        ],
      'items-per-page-text': 'Filas por página',
      showFirstLastPage: true,
    }
  }
}
